<template>
  <div class="modal__content container">
    <h3 class="text-center text-regular mb20">Upload your designs</h3>


    <dropzone id="projectDesignerFilesUpload" ref="dropzone" url="/upload/file" @vdropzone-success="showSuccess"
              @vdropzone-removed-file="onFileRemove" @vdropzone-sending="onSending"
              @vdropzone-queue-complete="onUploaded" useCustomDropzoneOptions
              :dropzoneOptions="dropzoneOptions"></dropzone>

    <div class="flex flex--justify-center mt20">
      <button class="btn btn--gray-2 mr5" @click="$bus.$emit('modalClose')" type="button">Close</button>
      <button class="btn" @click="onConfirm" :class="{'btn--disabled': uploading}" :disabled="uploading">Submit
      </button>
    </div>
  </div>
</template>

<script>
  import Dropzone from 'vue2-dropzone'
  import { mapActions } from 'vuex'
  import { apiAddDesignsFileKeys } from '@/api/task.api'

  export default {
    components: {
      Dropzone
    },

    data () {
      return {
        addedDesignsFileKeys: [],
        uploading: false,
        dropzoneOptions: {
          dictDefaultMessage: '<span class="icon-arrow-up-bold-circle text-color-green h4"></span><span class="dz-drop-text">Drop your files here</span>',
          previewTemplate: '<div class="dz-preview dz-file-preview">' +
          '<div class="dz-image"><img data-dz-thumbnail /></div>' +
          '<div class="dz-details">' +
          '<div class="dz-filename"><span data-dz-name></span></div>' +
          '<div class="dz-size" data-dz-size></div>' +
          '</div>' +
          '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
          '<div class="dz-success-mark dz-success-mark--modal-upload"><span class="icon-check"></span></div>' +
          '<div class="dz-error-mark dz-error-mark--modal-upload"><span class="icon-remove"></span></div>' +
          '<div class="dz-error-message"><span data-dz-errormessage></span></div>' +
          '<div class="dz-remove" data-dz-remove><span class="icon-remove"></span></div>' +
          '</div>'
        }
      }
    },

    props: {
      args: {
        type: Object,
        required: true
      }
    },

    created () {
    },

    methods: {
      ...mapActions([
        'updateActiveTaskProperties'
      ]),

      onSending () {
        this.uploading = true
      },

      onUploaded () {
        this.uploading = false
      },

      showSuccess (file, response) {
        this.addedDesignsFileKeys.unshift(response.key)
      },

      async onConfirm () {
        this.uploading = true
        const projectID = this.$route.params.id
        const [err, data] = await apiAddDesignsFileKeys(projectID, this.args.taskId, this.addedDesignsFileKeys)
        if (err) return errorMessage(err, 'Unable to add design!')

        this.$bus.$emit('modalClose')
        return this.updateActiveTaskProperties({
          taskId: this.args.taskId,
          properties: { designerFileList: data.designerFileList, designZipLink: '' }
        })
      },

      onFileRemove (file) {
        if (file.xhr.response) {
          const response = JSON.parse(file.xhr.response)
          this.addedDesignsFileKeys = _.filter(this.addedDesignsFileKeys, key => {
            return key !== response.key
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UploadDesignerFilesModal.vue?5cff03e5